<header>
    <h3>{{ 'pages.profile.addresses.verify' | translate }}</h3>
    <button mat-icon-button aria-label="Close" (click)="cancel()">
        <span class="icon-close"></span>
    </button>
</header>

<div class="dialog-content">
    <div class="section">
        <div class="section-header">
            <mat-icon>home</mat-icon>
            <span>{{ data.displayName | uppercase }}</span>
        </div>
        <div class="section-body">
            <div class="address-row">
                <mat-icon>location_on</mat-icon>
                <div class="address-text">
                    <span class="address-line1">{{ addressLine1 }}</span>
                    <span class="address-line2">{{ addressLine2 }}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="subtype-selector">
        <app-form-select
            [(ngModel)]="selectedSubType"
            name="subType"
            [options]="subTypeOptions"
            placeholder="{{ 'pages.user-cards.create.steps.information.subTypes.label' | translate }}"
            label="{{ 'pages.user-cards.create.steps.information.subTypes.label' | translate }} *">
        </app-form-select>
    </div>
</div>

<footer>
    <button
        class="bciti-button bciti-button--blue-inversed"
        (click)="cancel()">
        {{ 'pages.residences.reviewDialog.cancelButton' | translate }}
    </button>
    <button
        class="bciti-button bciti-button--blue"
        (click)="confirm()"
        [disabled]="!selectedSubType">
        {{ 'pages.profile.addresses.verifyButton' | translate }}
    </button>
</footer>
